<template>
    <div class="page-body">
        <div class="table-body">
            <div class="table-header">
                <div class="handle-box">
                    <table width="100%">
                        <tr>
                            <td class="td-text">
                                申请编号：
                            </td>
                            <td class="td-input">
                                <el-input v-model="searchItem.applyNum" size="small" placeholder="请输入协议申请编号"
                                ></el-input>
                            </td>
                            <td class="td-text">
                                销售人员：
                            </td>
                            <td class="td-input">
                                <el-select v-model="searchItem.userName" size="small"
                                           style="width: 100%"
                                           filterable
                                           placeholder="请选择销售人员">
                                    <el-option
                                            v-for="item in saleList"
                                            :key="item"
                                            :label="item"
                                            :value="item">
                                    </el-option>
                                </el-select>
                            </td>
                            <td class="td-text">
                                联系电话：
                            </td>
                            <td class="td-input">
                                <el-input v-model="searchItem.userTel" size="small" placeholder="请输入销售人员电话"
                                ></el-input>
                            </td>
                        </tr>
                        <tr>
                            <td class="td-text" style="padding-top: 10px">
                                申请时间：
                            </td>
                            <td class="td-input" style="width: 400px;padding-top: 10px">
                                <el-date-picker
                                        v-model="searchItem.startDate"
                                        type="date"
                                        size="small"
                                        placeholder="选择日期时间"
                                        style="width: 47%;"
                                        class="handle-input-date"
                                        value-format="yyyy-MM-dd">
                                </el-date-picker>
                                至
                                <el-date-picker
                                        v-model="searchItem.endDate"
                                        type="date"
                                        placeholder="选择日期时间"
                                        size="small"
                                        style="width: 47%;"
                                        class="handle-input-date"
                                        value-format="yyyy-MM-dd">
                                </el-date-picker>
                            </td>
                            <td class="td-text" style="padding-top: 10px">
                                公司名称：
                            </td>
                            <td class="td-input" style="padding-top: 10px">
                                <el-input v-model="searchItem.companyName" size="small" placeholder="请输入公司名称"
                                ></el-input>
                            </td>
                            <td class="td-text" style="padding-top: 10px">
                                公司类型：
                            </td>
                            <td class="td-input" style="padding-top: 10px">
                                <el-select v-model="searchItem.companyType" size="small" style="width: 100%;"
                                           placeholder="请选择公司类型">
                                    <el-option
                                            v-for="item in unitTypes"
                                            :key="item.value"
                                            :label="item.label"
                                            :value="item.value">
                                    </el-option>
                                </el-select>
                            </td>
                        </tr>
                        <tr>
                            <td style="text-align: right;padding-top: 10px">项目名称：</td>
                            <td style="padding-top: 10px">
                                <el-input v-model="searchItem.projectName" size="small" placeholder="请输入项目名称"
                                ></el-input>
                            </td>
                            <td></td>
                            <td></td>
                            <td style="padding-top: 10px;text-align: center" colspan="2">

                                <!--<el-button type="primary" icon="el-icon-download" size="small" @click="exportExcel" disabled>导出为Excel文件
                                </el-button>-->
                                <el-button type="primary" icon="el-icon-search" size="small"
                                           @click="searchBtn">搜索
                                </el-button>
                                <el-button type="primary" style="margin-left: 25%" icon="el-icon-refresh-right"
                                           size="small" @click="resetBtn">
                                    重置
                                </el-button>
                            </td>
                        </tr>
                    </table>
                </div>
            </div>
            <div class="table-info">
                <div class="table-button">
                    <div>
                        <el-table
                                :data="tableData"
                                :max-height="tableHeight"
                                style="width: 100%;height: 100%;"
                                :border="true"
                                :header-cell-style="{ background: '#EBEEF8',height: '50px', 'text-align':'center' }"
                                :cell-style="{padding:'0',height: lineHeight}">
                            <el-table-column type="index" label="序号" width="50" align="center"></el-table-column>
                            <el-table-column prop="applyNum" label="申请编号" width="150" align="center"
                                             show-overflow-tooltip></el-table-column>
                            <!-- <el-table-column prop="testType" label="协议类型" width="120" align="center"></el-table-column>-->
                            <el-table-column prop="userName" label="销售人员" width="100" align="center"></el-table-column>
                            <el-table-column prop="userTel" label="联系电话" width="110" align="center"></el-table-column>
                            <el-table-column prop="towerCount" label="塔机" width="70" align="center"></el-table-column>
                            <el-table-column prop="lifterCount" label="升降机" width="70" align="center"></el-table-column>
                            <el-table-column label="测试周期" width="120" align="center" show-overflow-tooltip>
                                <template slot-scope="scope">
                                    <span>{{scope.row.startDate}} ~ {{scope.row.endDate}}</span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="companyName" label="公司名称" width="240"
                                             show-overflow-tooltip></el-table-column>
                            <el-table-column prop="companyType" label="公司类型" width="100" align="center">
                                <template slot-scope="scope">
                                    <span v-if="scope.row.companyType == 0">建机厂</span>
                                    <span v-if="scope.row.companyType == 1">国企</span>
                                    <span v-if="scope.row.companyType == 2">租赁商</span>
                                    <span v-if="scope.row.companyType == 3">代理商</span>
                                    <span v-if="scope.row.companyType == 4">集团公司</span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="projectName" label="项目名称" width="140" show-overflow-tooltip
                                             align="left">
                                <template slot-scope="scope">
                                    <span v-if="scope.row.projectName == ''||scope.row.projectName==undefined">无</span>
                                    <span v-else>{{scope.row.projectName}}</span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="createTime" label="申请时间" :formatter="dateFormat" width="100"
                                             align="center" show-overflow-tooltip></el-table-column>
                            <el-table-column prop="auditState" label="审批状态" width="100" align="center">
                                <template slot-scope="scope">
                                    <span v-if="scope.row.auditState == 1" style="color: blue">待审批</span>
                                    <span v-else-if="scope.row.auditState == -1" style="color: red">已驳回</span>
                                    <span v-else style="color: green">已审批</span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="remark" label="备注" align="center"
                                             show-overflow-tooltip></el-table-column>
                            <el-table-column prop="id" label="操作" width="150" align="center">
                                <template slot-scope="scope">
                                    <div class="opertion" v-if="isSalesman == 'false'">
                                        <i class="iconfont iconbohui" title="驳回申请"
                                           v-if="scope.row.auditState == 1 && hasAuthority('test_approval_convert') "
                                           @click="refuseTestApprove(scope.row.id)"></i>
                                        <i class="iconfont iconxiangqing" title="查看详情"
                                           @click="showTest(scope.row.id)"></i>
                                        <i class="iconfont iconshengchenghetong"
                                           v-if="scope.row.auditState == 1 && hasAuthority('test_approval_convert')"
                                           title="生成协议" @click="createTestProtocol(scope.row.id)"></i>
                                    </div>
                                    <div v-else>
                                        <i class="iconfont iconxiangqing" style="margin-left: 30%" title="查看详情"
                                           @click="showTest(scope.row.id)"></i>
                                    </div>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                </div>
                <div class="table-data">
                    <Pagination :pageSize="option.pageSize" :pageTotal="totalPage" :pageCurrent.sync="option.pageIndex"
                                :pageList="pageList" @handlePageChange="pageChange" @handleSizeChange="pageSizeChange"/>
                </div>
            </div>
        </div>
        <div class="information">
            <el-dialog
                    :title="showTitle"
                    :visible.sync="infoVisible"
                    width="72%"
                    :close-on-click-modal="false"
                    style="margin-top: -90px"
                    center>
                <div class="dialog-body">
                    <div class="basic-info">
                        <div class="text-title">
                            基础信息
                        </div>
                        <div>
                            <table style="text-align: left; width: 100%">
                                <tr>
                                    <td style="padding: 10px;width: 120px">
                                        公司名称：
                                    </td>
                                    <td style="width: 300px;">
                                        {{testDisplay.companyName}}
                                    </td>
                                    <td style="padding: 10px;width: 120px">协议号：</td>
                                    <td style="width: 170px">
                                        {{testDisplay.applyNum}}
                                    </td>
                                    <td style="padding: 10px;width: 120px">测试周期：</td>
                                    <td style="width: 300px">
                                        {{testDisplay.startDate}} ~ {{testDisplay.endDate}}
                                    </td>
                                </tr>
                                <tr>
                                    <td style="padding: 10px;width: 120px">
                                        项目名称：
                                    </td>
                                    <td style="width: 300px;">
                                        {{testDisplay.projectName}}
                                    </td>
                                    <td style="padding: 10px;width: 120px">塔机数量：</td>
                                    <td style="width: 170px">
                                        {{testDisplay.towerCount}}
                                    </td>
                                    <td style="padding: 10px;width: 120px">升降数量：</td>
                                    <td style="width: 170px">
                                        {{testDisplay.lifterCount}}
                                    </td>
                                </tr>
                                <tr>
                                    <td style="padding: 10px;width: 140px">
                                        是否安装：
                                    </td>
                                    <td style="width: 300px;">
                                        {{testDisplay.isInstall == 1?"是":"否"}}
                                    </td>
                                    <td style="padding: 10px;width: 140px">
                                        设备类型：
                                    </td>
                                    <td style="width: 300px;">
                                        {{testDisplay.deviceType == 1?"加强型":"普通型"}}
                                    </td>
                                    <td style="padding: 10px;width: 140px">
                                        公司类型：
                                    </td>
                                    <td style="width: 300px;">
                                        {{testDisplay.companyType==0?'建机厂':(testDisplay.companyType==1?'国企':(testDisplay.companyType==2?'租赁商':(testDisplay.companyType==3?'代理商':'集团公司')))}}
                                    </td>
                                </tr>
                                <tr>
                                    <td style="padding: 10px;width: 120px">
                                        备注：
                                    </td>
                                    <td style="width: 300px;" colspan="5">
                                        {{testDisplay.remark}}
                                    </td>
                                </tr>
                                <tr>
                                    <td>功能需求：</td>
                                    <td colspan="5" style="padding: 10px 0;">
                                        <div class="td-body">
                                            <table cellpadding="0" cellspacing="0" style="width: 100%">
                                                <tr>
                                                    <td style="border: 1px solid #EBEEF8;padding: 3px; text-align: center">
                                                        序号
                                                    </td>
                                                    <td :key="i" v-for="(item,i) in towerItems"
                                                        style="border: 1px solid #EBEEF8;padding: 3px;text-align: center">
                                                        {{item.index}}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td style="border: 1px solid #EBEEF8;text-overflow:ellipsis;padding: 3px; text-align: center">
                                                        塔机
                                                    </td>
                                                    <td :key="i" v-for="(item,i) in towerItems"
                                                        style="border: 1px solid #EBEEF8;padding: 3px;text-align: center">
                                                        {{item.text}}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td style="border: 1px solid #EBEEF8;padding: 3px;text-align: center">
                                                        数量
                                                    </td>
                                                    <td :key="i" v-for="(item,i) in towerItems"
                                                        style="text-align: center;border: 1px solid #EBEEF8;padding: 3px;">
                                                        {{item.quality}}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td style="border: 1px solid #EBEEF8;padding: 3px; text-align: center">
                                                        升降机
                                                    </td>
                                                    <td :key="i" v-for="(item,i) in lifterItems"
                                                        style="border: 1px solid #EBEEF8;padding: 3px;text-align: center">
                                                        {{item.text}}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td style="border: 1px solid #EBEEF8;padding: 3px;text-align: center">
                                                        数量
                                                    </td>
                                                    <td :key="i" v-for="(item,i) in lifterItems"
                                                        style="text-align: center;border: 1px solid #EBEEF8;padding: 3px;">
                                                        {{item.quality}}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td style="border: 1px solid #EBEEF8;padding: 3px; text-align: center">
                                                        特殊型号
                                                    </td>
                                                    <td :key="i" v-for="(item,i) in specialItems"
                                                        style="border: 1px solid #EBEEF8;padding: 3px;text-align: center">
                                                        {{item.text}}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td style="border: 1px solid #EBEEF8;padding: 3px;text-align: center">
                                                        数量
                                                    </td>
                                                    <td :key="i" v-for="(item,i) in specialItems"
                                                        style="text-align: center;border: 1px solid #EBEEF8;padding: 3px;">
                                                        {{item.quality}}
                                                    </td>
                                                </tr>
                                            </table>
                                        </div>
                                    </td>
                                </tr>
                            </table>
                            <template>
                                <el-table
                                        :data="basicTable"
                                        style="width: 100%"
                                        border
                                        :header-cell-style="{ background: '#EBEEF8',height: '50px', 'text-align':'center' }"
                                        :cell-style="{padding:'0',height: '41px'}">
                                    <el-table-column type="index" label="序号" width="50px" align="center"></el-table-column>
                                    <el-table-column prop="deviceCategory" label="设备类型" align="center">
                                        <template slot-scope="scope">
                                            <span v-if="scope.row.deviceCategory == 1">升降机</span>
                                            <span v-else>塔机</span>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="sizeModel" label="规格型号" align="center"></el-table-column>
                                    <el-table-column prop="siteNum" label="现场编码" align="center"></el-table-column>
                                    <el-table-column prop="stringDiameter" label="钢丝绳直径(mm)"
                                                     align="center"></el-table-column>
                                    <el-table-column prop="armLength" label="前臂长度(m)" align="center"></el-table-column>
									<el-table-column prop="rearArmLength" label="后臂长度(m)" align="center"></el-table-column>
                                    <el-table-column prop="maxLoad" label="最大载重(T)" align="center"></el-table-column>
                                    <el-table-column prop="deviceType" label="类型" align="center"></el-table-column>
                                    <el-table-column prop="isNeedCard" label="是否需要视频流量卡" align="center">
                                        <template slot-scope="scope">
                                            <span v-if="scope.row.isNeedCard == 1">是</span>
                                            <span v-else>否</span>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="isNeedModel" align="center" label="是否需要现场调试多塔防碰撞功能">
                                        <template slot-scope="scope">
                                            <span v-if="scope.row.isNeedModel == 1">是</span>
                                            <span v-else>否</span>
                                        </template>
                                    </el-table-column>
                                </el-table>
                            </template>
                        </div>
                        <div class="upload-files">
                            <div class="text-title">
                                附件信息
                            </div>
                            <div class="file-type">
                                <div style="width: 7%;padding: 10px">
                                    设备型号清单:
                                </div>
                                <div style="width: 6%">
                                    <el-tooltip class="item" effect="dark" content="点此上传设备信息清单" placement="top-start">
                                        <el-button type="text" v-if="isPass == 1" @click="uploadList(0)">点此上传
                                        </el-button>
                                        <el-button type="text" v-else disabled>点此上传</el-button>
                                    </el-tooltip>
                                </div>
                                <div style="width: 87%;padding: 12px">
                                    <span>{{testDisplay.deviceListUrl != ''?testDisplay.deviceListUrl.split('/').slice(-1) + '':''}}</span>
                                </div>
                            </div>
                            <div class="file-type">
                                <div style="width: 7%;padding: 10px">
                                    项目信息清单:
                                </div>
                                <div style="width: 6%">
                                    <el-tooltip class="item" effect="dark" content="点此上传设备信息清单" placement="top-start">
                                        <el-button type="text" v-if="isPass == 1" @click="uploadList(1)">点此上传
                                        </el-button>
                                        <el-button type="text" v-else disabled>点此上传</el-button>
                                    </el-tooltip>
                                </div>
                                <div style="width: 87%;padding: 12px">
                                    <span>{{testDisplay.projectMsgUrl != ''?testDisplay.projectMsgUrl.split('/').slice(-1) + '':''}}</span>
                                </div>
                            </div>
                            <div class="file-type">
                                <div style="width: 7%;padding: 10px">
                                    其它附件:
                                </div>
                                <div style="width: 6%">
                                    <el-tooltip class="item" effect="dark" content="点此上传设备信息清单" placement="top-start">
                                        <el-button type="text" v-if="isPass == 1" @click="uploadList(2,testId)">点此上传
                                        </el-button>
                                        <el-button type="text" v-else disabled>点此上传</el-button>
                                    </el-tooltip>
                                </div>
                                <div style="width: 87%;padding: 12px">
                                    <span>{{testDisplay.otherAttachUrl != ''?testDisplay.otherAttachUrl.split('/').slice(-1) + '':''}}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <span slot="footer" class="dialog-footer">
                    <el-button type="normal" @click="closeDialog">取 消</el-button>
                    <el-button type="primary" @click="submitAndSave">确 定</el-button>
                </span>
            </el-dialog>
        </div>
        <div class="upload">
            <el-dialog
                    :title="uploadTitle"
                    :visible.sync="fileDialog"
                    width="410px"
                    :close-on-click-modal="false"
                    center>
                <el-upload
                        class="upload-demo"
                        drag
                        ref="upload"
                        style="width: 100%"
                        :action='url'
                        :before-upload="handleBeforeUpload"
                        :on-success="getSuccessData"
                        :on-error="getErrorData"
                        multiple>
                    <i class="el-icon-upload"></i>
                    <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                    <div class="el-upload__tip" slot="tip">{{tipMessage}}</div>
                </el-upload>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="cancelFile">取 消</el-button>
                    <el-button type="primary" @click="submitFile">确 定</el-button>
                </span>
            </el-dialog>
        </div>
    </div>
</template>

<script>
    import funOptions from '../../../public/json/funOptions.json'
    import basicData from '../../../public/json/basicData.json'

    var pathURL = process.env.VUE_APP_CURENV;

    export default {
        data() {
            return {
                tableHeight: '',
                pageList: [14, 20, 30, 50],
                lineHeight: '',
                testId: '',
                uploadTitle: '',
                fileDialog: false,
                url: '',
                basicTable: [],
                checkAll: false,
                functions: [],
                funNameList: [],
                filePath1: '',
                filePath2: '',
                filePath3: '',
                isPass: '',
                isIndeterminate: false,
                dialogVisibles: false,
                shippingVisible: false,
                infoVisible: false,
                multipleSelection: [],
                saleList: [],
                delList: [],
                // totalPage:0,
                searchItem: {
                    applyNum: '',
                    userName: '',
                    userTel: '',
                    startDate: '',
                    endDate: '',
                    companyName: '',
                    projectName: '',
                    companyType: null,
                    pageSize: 14
                },
                pageIndex: 1,
                totalPage: 30,
                dialogVisible: false,
                option: {
                    pageIndex: '',
                    pageSize: 14,
                    currentPage: 2
                },
                approvalStatuses: [
                    {
                        label: '已通过',
                        value: 1
                    },
                    {
                        label: '未通过',
                        value: 2
                    },
                ],
                towerItems: [],
                lifterItems: [],
                specialItems: [],
                unitTypes: [
                    {
                        label: '建机厂',
                        value: 0
                    },
                    {
                        label: '国企',
                        value: 1
                    },
                    {
                        label: '租赁商',
                        value: 2
                    },
                    {
                        label: '代理商',
                        value: 3
                    },
                    {
                        label: '集团公司',
                        value: 4
                    },
                ],
                dataSource: {},
                flag: 0,
                UpDialogVisible: false,
                tableData: [],
                testForm: {
                    id: '',
                    deviceListUrl: "",
                    projectMsgUrl: "",
                    otherAttachUrl: "",
                },
                rules: {
                    name: [{required: true, message: '协议名称不能为空', trigger: 'blur'}],
                    number: [{required: true, message: '协议号不能为空', trigger: 'blur'}],
                    companyName: [{required: true, message: '公司名称不能为空', trigger: 'blur'}],
                    startDate: [{required: true, message: '开始时间不能为空', trigger: 'blur'}],
                    endDate: [{required: true, message: '截止时间不能为空', trigger: 'blur'}],
                    quality: [{required: true, message: '数量不能为空', trigger: 'blur'}]
                },
                testDisplay: {
                    applyNum: "",
                    createTime: "",
                    auditState: 0,
                    companyName: "",
                    deviceListUrl: "",
                    deviceType: '',
                    projectMsgUrl: "",
                    otherAttachUrl: "",
                    companyType: 0,
                    customerId: null,
                    endDate: "",
                    isInstall: '',
                    id: "",
                    lifterCount: 2,
                    lifterMap: null,
                    remark: "",
                    startDate: "",
                    towerCount: 2,
                    towerMap: "",
                    userName: "",
                    userTel: "",
                    projectName: ''
                },
                isClose: false,
                showTitle: '',
                isSalesman: '',
                tipMessage: ''
            }
        },
        methods: {
            dateFormat(row, column) {
                let data = row[column.property]
                let dt = new Date(data)
                var year = dt.getFullYear();
                var month = (dt.getMonth() + 1) < 10 ? 0 + '' + (dt.getMonth() + 1) : ((dt.getMonth() + 1))
                var date = dt.getDate() < 10 ? 0 + '' + dt.getDate() : (dt.getDate())
                return year + '-' + month + '-' + date
            },
            saveTest(formName) {
                this.$refs[formName].validate(item => {
                    if (item) {
                    } else {
                        this.$message.error("输入的数据有误")
                    }
                })
            },
            resetBtn() {
                this.searchItem = {
                    applyNum: '',
                    userName: '',
                    userTel: '',
                    startDate: '',
                    endDate: '',
                    companyName: '',
                    projectName: '',
                    companyType: null,
                    pageSize: 14
                },
                    this.searchBtn();
            },
            shippingShow(row) {
                this.shippingVisible = true;
            },
            pageChange(option) {
                if(option != "refresh"){
                    this.option.pageIndex = option;
                    this.searchItem.pageIndex = option;
                }
                this.$api.pageTestApproval(this.searchItem).then(res => {
                    if (res.code == 200) {
                        this.tableData = res.data.content;
                        this.totalPage = res.data.totalElements;
                    }
                })
            },
            pageSizeChange(val) {
                this.searchItem.pageSize = val;
                this.$api.pageTestApproval(this.searchItem).then(res => {
                    if (res.code == 200) {
                        this.tableData = res.data.content;
                        this.totalPage = res.data.totalElements;
                    }
                })
            },
            chooseSelection(val) {
                this.multipleSelection = val;
            },
            deleteTest(id) {

            },
            exportExcel() {

            },
            createTestProtocol(id) {
                this.$confirm('你确定要生成该协议信息吗？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning',
                    center: true
                }).then(() => {
                    this.$api.createTest({id}).then(res => {
                        if (res.code == 200) {
                            this.$message.success(res.message);
                            this.$router.push("/testProtocol?id=" + id);
                        } else {
                            this.$message.error(res.message);
                        }
                    })
                }).catch(() => {
                })
            },
            refuseTestApprove(id) {
                this.$confirm('你确定要驳回该申请信息吗？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning',
                    center: true
                }).then(() => {
                    this.$api.createTest({id: id, isReject: 1}).then(res => {
                        if (res.code == 200) {
                            this.pageChange("refresh")
                            this.$message.success(res.message);
                        } else {
                            this.$message.success(res.message);
                        }
                    })
                }).catch(() => {
                })
            },
            searchBtn() {
                this.pageChange(1)
            },
            uploadList(val) {
                this.url = pathURL + 'erp/file/upload?businessType=list&access_token=' + localStorage.getItem("accessToken")
                this.fileDialog = true
                if (val == 0) {
                    this.uploadTitle = '上传设备型号清单';
                    this.tipMessage = '只能上传excel文件';
                    this.flag = 0
                } else if (val == 1) {
                    this.uploadTitle = '上传项目信息清单'
                    this.tipMessage = '只能上传excel文件';
                    this.flag = 1
                } else {
                    this.uploadTitle = '上传其它附件'
                    this.tipMessage = '可以上传*.xls,*.doc,*.png等';
                    this.flag = 2
                }
            },
            getSuccessData(res) {
                if (res.code == 200) {
                    if (this.flag == 0) {
                        this.testForm.deviceListUrl = res.data.filePath
                        this.testDisplay.deviceListUrl = res.data.filePath
                    } else if (this.flag == 1) {
                        this.testForm.projectMsgUrl = res.data.filePath
                        this.testDisplay.projectMsgUrl = res.data.filePath
                    } else {
                        this.testForm.otherAttachUrl = res.data.filePath
                        this.testDisplay.otherAttachUrl = res.data.filePath
                    }
                } else {
                    this.$message.error(res.message)
                }
            },
            getErrorData(res) {
                this.$message.error(res.message)
            },
            cancelFile() {
                this.fileDialog = false;
                this.$refs.upload.clearFiles();
            },
            submitFile() {
                this.fileDialog = false;
                this.$refs.upload.clearFiles();
            },
            closeDialog() {
                this.infoVisible = false;
            },
            submitAndSave() {
                if (this.isPass != 10) {
                    this.$api.analysisAboutTest(this.testForm).then(res => {
                        if (res.code == 200) {
                            this.infoVisible = false;
                            this.$message.success(res.message)
                        } else {
                            this.$message.error(res.message)
                        }
                    })
                } else {
                    this.infoVisible = false;
                }

            },
            showTest: function (id) {
                this.infoVisible = true;
                this.towerItems = [];
                this.lifterItems = [];
                this.$api.getTestApprovalById({id}).then(res => {
                    if (res.code == 200) {
                        this.testDisplay = {
                            applyNum: res.data.applyNum,
                            createTime: res.data.createTime,
                            auditState: res.data.auditState,
                            companyName: res.data.companyName,
                            companyType: res.data.companyType,
                            customerId: res.data.customerId,
                            deviceType: res.data.deviceType,
                            endDate: res.data.endDate,
                            id: res.data.id,
                            isInstall: res.data.isInstalled,
                            lifterCount: res.data.lifterCount,
                            lifterMap: res.data.lifterMap,
                            remark: res.data.remark,
                            startDate: res.data.startDate,
                            towerCount: res.data.towerCount,
                            towerMap: res.data.towerMap,
                            userName: res.data.userName,
                            userTel: res.data.userTel,
                            projectName: res.data.projectName,
                            deviceListUrl: res.data.deviceListUrl,
                            projectMsgUrl: res.data.projectMsgUrl,
                            otherAttachUrl: res.data.otherAttachUrl,
                        };
                        this.testForm = {
                            id: res.data.id,
                            projectMsgUrl: res.data.projectMsgUrl,
                            otherAttachUrl: res.data.otherAttachUrl,
                            deviceListUrl: res.data.deviceListUrl,
                        }
                        this.isPass = res.data.auditState;
                        this.basicTable = res.data.deviceList;
                        this.showTitle = '《' + res.data.applyNum + '》详情信息'
                        var towerItemsStr = res.data.towerMap;
                        if (towerItemsStr) {
                            var funcItem = {};
                            var index = 1
                            for (var i in towerItemsStr) {
                                funcItem = {text: '', quality: 0}
                                funcItem.text = i;
                                funcItem.index = index;
                                funcItem.quality = towerItemsStr[i];
                                this.towerItems.push(funcItem);
                                index = index + 1
                            }
                        }
                        var lifterItemsStr = res.data.lifterMap;
                        if (lifterItemsStr) {
                            var funcItem = {};
                            for (var i in lifterItemsStr) {
                                funcItem = {text: '', quality: 0}
                                funcItem.text = i;
                                funcItem.quality = lifterItemsStr[i];
                                this.lifterItems.push(funcItem);
                            }
                        }
                        var specialItemsStr = res.data.specialMap;
                        if (specialItemsStr) {
                            var funcItem = {};
                            for (var i in specialItemsStr) {
                                funcItem = {text: '', quality: 0}
                                funcItem.text = i;
                                funcItem.quality = specialItemsStr[i];
                                this.specialItems.push(funcItem);
                            }
                        }
                    } else {
                        this.$message.error(res.message)
                    }
                })
            },

            handleCheckAllChange(val) {
                this.testForm.demand = val ? this.functions : [];
                this.isIndeterminate = false;
            },
            handleCheckedFunctionsChange(value) {
                let checkedCount = value.length;
                this.checkAll = checkedCount === this.functions.length;
                this.isIndeterminate = checkedCount > 0 && checkedCount < this.functions.length;
            },
            handleBeforeUpload(file) {
                const typeList = ["xls", "xlsx"];
                const errMsg = '请上传excel文件'
                if (this.flag == 0 || this.flag == 1) {
                    return this.beforeUpload(file, typeList, errMsg)
                }
            },
            beforeUpload(file, arr = [], mssage) {
                const typeList = [...arr];
                const fileName = file.name;
                const extension = fileName.substr(fileName.lastIndexOf(".") + 1);
                const isRT = typeList.includes(extension);
                if (!isRT) {
                    this.$message.error(mssage);
                }
                return isRT;
            }
        },
        created() {
            this.tableHeight = (window.innerHeight) * 0.67
            this.searchBtn()
            this.$api.getSaleList().then(res => {
                if (res.code == 200){
                    this.saleList = res.data
                }
            })
            this.isSalesman = localStorage.getItem("isSalesman");
            this.basicTable = basicData.data;
            this.functions = funOptions.data;
            if (window.screen.height > 900) {
                this.lineHeight = window.screen.height * 0.038 + 'px';
            } else {
                this.lineHeight = window.screen.height * 0.033 + 'px';
            }
        }
    }
</script>

<style lang="scss" scoped>

    .text-title {
        font-size: 16px;
        font-weight: bold;
        color: #437EE6;
        text-align: center;
        margin-bottom: 20px;
    }

    .dialog-body {
        max-height: 650px;
        overflow-y: scroll;
    }

    .opertion {
        display: flex;
        justify-content: center;
    }

    .iconfont {
        font-family: "iconfont" !important;
        font-size: 20px;
        font-style: normal;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        margin-top: 3px;
        display: block;
        cursor: pointer;
    }


    .iconshengchenghetong {
        margin-left: 20px;
    }

    .iconbohui {
        color: red;
        margin-right: 20px;
    }

    .page-body {
        background-color: #FFFFFF;
        height: 100%;
        width: 100%;
        display: flex;
        flex-direction: column;
    }

    .table-body {
        display: flex;
        flex-direction: column;
        height: 100%;
    }

    .table-header {
        height: 17%;
        margin-top: 10px;
        background-color: #FFFFFF;
    }

    .handle-box {
        padding: 5px 10px;
    }

    .table-info {
        height: 94%;
        margin-top: 5px;
        background-color: #FFFFFF;
        display: flex;
        flex-direction: column;
    }

    .table-button {
        flex: 1;
        margin: 0 1%;
    }

    .table-data {
        height: 6%;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .handle-input {
        width: 400px;
        display: inline-block;
    }

    .handle-input-date {
        width: 150px;
        display: inline-block;
        padding-right: 0px;
    }

    .information {
        background-color: #F0F2F5;
    }

    .dialog-title {
        margin: 0 20px;
        color: #67ADD9;
        font-size: 20px;
        /*border: 1px red solid;*/
    }

    .payment-table, .approval-table {
        margin-top: 10px;
    }

    .td-body {
        padding: 10px 0;
        white-space: nowrap;
        overflow-x: scroll;
        width: 1100px;
    }

    td {
        white-space: nowrap; /*控制单行显示*/
        overflow: hidden; /*超出隐藏*/
        text-overflow: ellipsis; /*隐藏的字符用省略号表示*/
    }

    .upload-files {
        margin-top: 50px;
    }

    .file-type {
        margin-top: 10px;
        width: 100%;
        display: flex;
    }

    .td-text {
        width: 90px;
        text-align: right;
    }

    .td-input {
        width: 28%;
    }
</style>
